/**
 * Tema explícito del Switch.
 *
 * Chakra construye el Switch sobre la misma maquinaria que el Checkbox, y
 * el override de `Checkbox.control` de este proyecto -borde cuadrado de
 * 2px sobre fondo blanco- lo dejaba prácticamente invisible. Definirlo
 * aquí lo desacopla del Checkbox y garantiza que se vea, con los tokens
 * del proyecto.
 */
const Switch = {
  baseStyle: {
    track: {
      bg: 'border.strong',
      _checked: { bg: 'accent.default' },
      _focusVisible: { boxShadow: 'outline' },
    },
    thumb: {
      bg: 'white',
    },
  },
  sizes: {
    md: {
      track: { w: '40px', h: '22px', p: '2px' },
      thumb: { w: '18px', h: '18px', _checked: { transform: 'translateX(18px)' } },
    },
  },
  defaultProps: { size: 'md' },
};

export default Switch;
